import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b560cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-icon-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_img = _resolveComponent("base-img")!
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_icon, null, {
      default: _withCtx(() => [
        _createVNode(_component_base_img, {
          src: "edit/edit-grey.svg",
          alt: "edit",
          width: "20",
          height: "20"
        })
      ]),
      _: 1
    })
  ]))
}